import React from 'react';

import { Permission } from '@amazd/common/utils';
import useLogin from 'hooks/useLogin';
import usePermission from 'hooks/usePermission';
import { NextPage } from 'next';
import CompanyProfileView from 'views/CompanyProfileView';

const CompanyProfilePage: NextPage = () => {
  const [, user] = useLogin(true);

  const canAccessCompanySettings = usePermission(Permission.COMPANY_SETTINGS);

  if (!user || !canAccessCompanySettings) {
    return null;
  }
  return <CompanyProfileView />;
};

export default CompanyProfilePage;
